// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container{height:24px}.container svg-icon{display:inline-block;position:relative;height:24px;min-height:24px;min-width:24px;width:24px}.container svg-icon svg{display:block;left:0;position:absolute;top:0;height:24px;min-height:24px;min-width:24px;width:24px}.container img{background-size:contain;border-radius:2px;object-fit:cover;object-position:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
